import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { Badge } from '@/components/ui/badge';
import { Archive, FolderKanban, RotateCcw } from 'lucide-react';
import { toast } from 'sonner';

export default function ArchivePage() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await api.get('/projects');
        setProjects(res.data.filter(p => p.status === 'Completed' || p.status === 'Archived'));
      } catch { toast.error('Failed to load'); }
      finally { setLoading(false); }
    };
    load();
  }, []);

  if (loading) return <div className="flex items-center justify-center h-64"><div className="w-6 h-6 border-2 border-[#3A8C8C] border-t-transparent rounded-full animate-spin" /></div>;

  return (
    <div className="space-y-6 animate-fade-in-up" data-testid="archive-page">
      <div>
        <h1 className="section-heading text-2xl font-['Manrope'] font-bold">Archive</h1>
        <p className="text-sm text-[#6B7280] mt-0.5">Completed and archived projects</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="archived-projects">
        {projects.map(p => (
          <div key={p.id} onClick={() => navigate(`/projects/${p.id}`)}
            className="glass-card rounded-2xl p-5 hover:shadow-md transition-all cursor-pointer"
            data-testid={`archived-project-${p.id}`}>
            <div className="flex items-start justify-between mb-2">
              <h3 className="font-semibold text-[#2C2C2E] text-sm font-['Manrope']">{p.name}</h3>
              <Badge className="bg-[#7DA68A]/10 text-[#7DA68A] text-[10px]">{p.status}</Badge>
            </div>
            <p className="text-xs text-[#6B7280]">{p.client_name}</p>
          </div>
        ))}
        {projects.length === 0 && (
          <div className="col-span-3 text-center py-16">
            <Archive size={32} strokeWidth={1.5} className="text-[#D4D0C8] mx-auto mb-3" />
            <p className="text-sm text-[#6B7280]">No archived projects yet</p>
          </div>
        )}
      </div>
    </div>
  );
}
